"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _RiskControlDialog = _interopRequireDefault(require("./components/RiskControlDialog"));
var _riskControl = require("@/api/riskControl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RiskControl',
  components: {
    RiskControlDialog: _RiskControlDialog.default
  },
  data: function data() {
    return {
      pagination: {
        total: 4
      },
      queryData: {
        account: '',
        accountType: '',
        timeRange: [],
        page: {
          page: 1,
          size: 20
        }
      },
      tableData: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var params = this.getQueryParams();
      (0, _riskControl.queryRiskBlacklistPaged)(params).then(function (res) {
        var data = res.data || {};
        _this.tableData = (data.data || []).map(function (item) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            reason: item.riskReason,
            adder: item.operatorName
          });
        });
        _this.pagination.total = data.total || 0;
      }).catch(function () {
        _this.tableData = [];
        _this.pagination.total = 0;
      });
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.getList();
    },
    getQueryParams: function getQueryParams() {
      var _this$queryData = this.queryData,
        account = _this$queryData.account,
        accountType = _this$queryData.accountType,
        timeRange = _this$queryData.timeRange,
        page = _this$queryData.page;
      var accountTypeMap = {
        phone: 1,
        alipay: 2
      };
      return {
        account: account,
        accountType: accountType ? accountTypeMap[accountType] : undefined,
        riskBeginTime: timeRange && timeRange[0] ? timeRange[0] : undefined,
        riskEndTime: timeRange && timeRange[1] ? timeRange[1] : undefined,
        page: page.page,
        size: page.size
      };
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        account: '',
        accountType: '',
        timeRange: [],
        page: {
          page: 1,
          size: 20
        }
      };
      this.getList();
    },
    onAdd: function onAdd() {
      this.$refs.RiskControlDialog.open({
        type: 'add',
        title: '新增风控名单'
      });
    },
    onEdit: function onEdit(row) {
      var accountTypeMap = {
        1: 'phone',
        2: 'alipay'
      };
      this.$refs.RiskControlDialog.open({
        type: 'edit',
        title: '编辑风控信息',
        row: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          accountType: accountTypeMap[row.accountType] || row.accountType
        })
      });
    },
    onRelease: function onRelease(row) {
      var _this2 = this;
      this.$confirm('确认解除用户风控状态？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _riskControl.removeRiskBlacklist)({
          ids: row.id
        }).then(function () {
          _this2.$message.success('解除成功');
          _this2.getList();
        });
      }).catch(function () {});
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.getList();
    },
    onRefresh: function onRefresh() {
      this.queryData.page.page = 1;
      this.getList();
    }
  }
};